/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/

angular.module('bulbApp.filtersModule')

/**
 * An Angular filter which allows a value to be displayed as html without being escaped.
 *
 * To get this to work you need to use ng-bind-html:
 * <ANY ng-bind-html="someValue | trustAsHtml"></ANY>
 * rather than
 * <ANY>{{someValue | trustAsHtml}}</ANY
 * as the second form doesn't work to use the value as html content.
 */
  .filter('trustAsHtml', ['$sce', function trustAsHtml($sce) {
    return $sce.trustAsHtml;
  }]);
